import { BarChart } from "@/components/analytics";
import { KpiReadout } from "@/components/ui/kpi-readout";

interface OverviewData {
  rows: number;
  columns: number;
  schema: Array<{ name: string; dtype: string; nullable: boolean }>;
}

interface OverviewVizProps {
  data: OverviewData;
}

export function OverviewViz({ data }: OverviewVizProps) {
  if (!data) return <p className="text-xs text-muted">No overview data.</p>;

  // Derive dtype counts from schema
  const dtypeCounts = (data.schema ?? []).reduce(
    (acc, col) => {
      acc[col.dtype] = (acc[col.dtype] || 0) + 1;
      return acc;
    },
    {} as Record<string, number>,
  );

  const dtypeData = Object.entries(dtypeCounts).map(([dtype, count]) => ({
    dtype,
    count,
  }));

  return (
    <div className="space-y-6">
      {/* KPI Strip */}
      <div className="grid grid-cols-2 gap-px rounded-[14px] border border-line bg-line overflow-hidden">
        <KpiReadout label="Rows" value={(data.rows ?? 0).toLocaleString()} />
        <KpiReadout label="Columns" value={(data.columns ?? 0).toLocaleString()} />
      </div>

      {/* Data Types Bar Chart */}
      {dtypeData.length > 0 && (
        <div>
          <h3 className="mb-3 font-mono text-sm font-semibold text-navy-600 dark:text-zinc-300">
            Data Types
          </h3>
          <BarChart data={dtypeData} dataKey="count" nameKey="dtype" height={200} />
        </div>
      )}
    </div>
  );
}
